import { Component, Inject } from "@angular/core";
import { NavController } from "ionic-angular";
import { LoginPage } from "../login.page/login.page";
import { Store } from "@ngrx/store";
import { AppState } from "../../app/models/app.state";
import * as UserActions from "../../app/store/actions/user.actions";
import { TranslateService } from "@ngx-translate/core";
import {
  EnvironmentVariables,
  ENV_VARS,
  envTypes
} from "../../app/environment-variables/environment-variables.module";

@Component({
  selector: "front-page",
  templateUrl: "front.page.html"
})
export class FrontPage {
  buildTimeStamp: string;
  versionNumber: string;
  language: "da-DK" | "en-GB";
  logoByEnv: { [key in envTypes]: string } = {
    prod: "assets/imgs/front_page_logo.png",
    dev: "assets/imgs/front_page_logo_dev.png",
    test: "assets/imgs/front_page_logo_test.png",
    kih: "assets/imgs/front_page_logo_kih.png"
  };
  logoUrl: string = "assets/imgs/front_page_logo.png";
  constructor(
    public navCtrl: NavController,
    public store: Store<AppState>,
    public translate: TranslateService,
    @Inject(ENV_VARS) public envVars: EnvironmentVariables
  ) {
    this.versionNumber = envVars.VERSION_NUMBER;
    this.buildTimeStamp = envVars.BUILD_TIMESTAMP;
    this.store.select(state => state.user).subscribe(user => {
      this.language = user.language;
    });
    this.logoUrl = this.logoByEnv[this.envVars.ENV] || this.logoByEnv["test"];
  }

  toLoginPage(resource) {
    this.navCtrl.push(LoginPage);
  }

  onLanguageChange(event) {
    this.store.dispatch(
      new UserActions.LanguageAction({
        language: this.language
      })
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/front.page/front.page.ts